import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('LIKES', {
  ADD_LIKE_REQUEST: null,
  ADD_LIKE_SUCCESS: null,
  ADD_LIKE_FAILURE: null,
  REMOVE_LIKE_REQUEST: null,
  REMOVE_LIKE_SUCCESS: null,
  REMOVE_LIKE_FAILURE: null
});
